// extracted by mini-css-extract-plugin
export default {"container":"BannerList_container__jjicb","banner":"BannerList_banner__sRv9q"};